module.exports = __webpack_public_path__ + "img/woman-holding-stone.e5c54217.jpeg";